var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"missing-agreement-box"},[_c('ywhz-title-style-card',{attrs:{"title":_vm.$t('menu.menu7'),"subtitle":"Lost protocol"}}),_c('div',{staticClass:"layout-width layout-r",attrs:{"id":"articlej"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }